<template>
  <div class="wallet">
    <div class="walletBg">
      <svg
        id="visual"
        viewBox="0 0 540 960"
        width="540"
        height="960"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.1"
      >
        <defs>
          <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
            <feDropShadow
              dx="0"
              dy="5"
              stdDeviation="10"
              flood-color="black"
              flood-opacity="0.3"
            />
          </filter>
        </defs>
        <path
          d="M0 211L30 222.5C60 234 120 257 180 266.3C240 275.7 300 271.3 360 264.8C420 258.3 480 249.7 510 245.3L540 241L540 0L510 0C480 0 420 0 360 0C300 0 240 0 180 0C120 0 60 0 30 0L0 0Z"
          fill="#0851a0"
          filter="url(#shadow)"
          stroke-linecap="round"
          stroke-linejoin="miter"
        />
      </svg>

      <!-- <svg
        id="visual"
        viewBox="0 0 540 960"
        width="540"
        height="960"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.1"
      >
        <defs>
          <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
            <feDropShadow
              dx="0"
              dy="6"
              stdDeviation="8"
              flood-color="black"
              flood-opacity="0.5"
            />
          </filter>
        </defs>

        <path
          d="M0 254L30 267.8C60 281.7 120 309.3 180 320.5C240 331.7 300 326.3 360 318.5C420 310.7 480 300.3 510 295.2L540 290L540 0L510 0C480 0 420 0 360 0C300 0 240 0 180 0C120 0 60 0 30 0L0 0Z"
          fill="#18a05f"
          filter="url(#shadow)"
          stroke-linecap="round"
          stroke-linejoin="miter"
        />
      </svg> -->
    </div>
    <div class="walletContent">
      <div class="contentTopNav">
        <h1 class="navTitle">
          <VsxIcon iconName="WalletAdd1" :size="28" color="#fff" type="bold" />
          کیف پول
        </h1>
        <!-- <div class="backBtn">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="size-6"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15.75 19.5 8.25 12l7.5-7.5"
            />
          </svg>
        </div> -->
      </div>
      <div class="contentHeader">
        <div class="headerTitle">موجودی</div>
        <div class="headerContent">
          <div class="contentNum">{{ formatPrice(userBox.credit) }}</div>
          <div class="contentUnit">تومان</div>
        </div>
      </div>
      <div class="contentMain">
        <div class="mainShortCuts">
          <div
            v-for="(item, index) in CreditDefults"
            @click="ShowMoneyToUSer(item)"
            :key="index"
            class="shortCutThumb"
          >
            {{ formatPrice(item) }}
          </div>
        </div>
        <div class="mainFormWrapper">
          <form class="mainForm">
            <div class="formGroup">
              <label for="" class="groupLabel">مبلغ را وارد کنید</label>
              <div class="groupInputWrapper">
                <input
                  type="text"
                  class="groupInput"
                  v-model="credit"
                  @input="price_input"
                  inputmode="numeric"
                />
                <div class="groupUnit">تومان</div>
              </div>
            </div>
            <div class="groupSubText" v-if="credit">
              {{ formattedWords }}
            </div>
            <div v-if="!loading" @click="BtnCharge" class="formSubmitBtn">
              افزایش اعتبار
            </div>
            <div v-if="loading" class="formSubmitBtn">
              <span class="whiteLoader"></span>
            </div>
          </form>

          <div
            v-if="SearchList1.length > 0 && $route.path != '/waiting-driver'"
            class="ShowHistoryToDriver"
          >
            <h2>تراکنش ها</h2>

            <div
              v-for="(SearchLists, index) in SearchList1"
              :key="index"
              class="ChildShowHistoryToDriver"
            >
              <div>
                <span> {{ SearchLists.date }}</span>
                <span style="margin-left: 7px"> {{ SearchLists.time }}</span>
              </div>
              <div class="ChildShowHistoryToDriverP">
                <span>تومان</span>

                <p>
                  {{ SearchLists.amount }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import {PerfectScrollbar} from "vue3-perfect-scrollbar";
import { mapGetters } from "vuex";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

export default {
  name: "creditUser",
  components: {
    // PerfectScrollbar,
  },
  data() {
    return {
      optionUser: "",
      userBox: "",
      credit: 0,
      SearchList1: [],
      CreditDefults: [],
      setState: "",
      time: "",
      text: "اعتبار شما کافی نمی باشد",
      snackbar: false,
      PageShow1: 0,
    };
  },
  computed: {
    ...mapGetters(["taxi_c_set"]),
    formattedWords() {
      const cleaned = this.credit.replace(/,/g, "");
      if (!cleaned || isNaN(cleaned)) return "";
      const asWords = this.numberToPersian(cleaned);
      return asWords;
    },
  },
  mounted() {
    let self = this;
    this.CreditDefults = this.taxi_c_set.credit_defult;
    self.getInfo();

    setInterval(() => {
      const now = new Date();
      const options = { hour: "numeric", minute: "numeric" };
      this.time = now.toLocaleTimeString([], options);
    }, 1000);
  },
  methods: {
    numberToPersian(num) {
      if (isNaN(num) || num === "") return "";

      const ones = [
        "",
        "یک",
        "دو",
        "سه",
        "چهار",
        "پنج",
        "شش",
        "هفت",
        "هشت",
        "نه",
      ];
      const tens = [
        "",
        "ده",
        "بیست",
        "سی",
        "چهل",
        "پنجاه",
        "شصت",
        "هفتاد",
        "هشتاد",
        "نود",
      ];
      const teens = [
        "ده",
        "یازده",
        "دوازده",
        "سیزده",
        "چهارده",
        "پانزده",
        "شانزده",
        "هفده",
        "هجده",
        "نوزده",
      ];
      const hundreds = [
        "",
        "یکصد",
        "دویست",
        "سیصد",
        "چهارصد",
        "پانصد",
        "ششصد",
        "هفتصد",
        "هشتصد",
        "نهصد",
      ];
      const thousands = ["", "هزار", "میلیون", "میلیارد", "تریلیون"];

      function threeDigitsToWord(n) {
        n = ("000" + n).slice(-3);
        const h = parseInt(n[0]);
        const t = parseInt(n[1]);
        const o = parseInt(n[2]);
        let word = [];

        if (h > 0) word.push(hundreds[h]);
        if (t > 1) {
          word.push(tens[t]);
          if (o > 0) word.push(ones[o]);
        } else if (t === 1) {
          word.push(teens[o]);
        } else if (o > 0) {
          word.push(ones[o]);
        }

        return word.join(" و ");
      }

      let str = parseInt(num).toString();
      if (str === "0") return "صفر";

      let parts = [];
      let counter = 0;
      while (str.length > 0) {
        let chunk = str.slice(-3);
        str = str.slice(0, -3);
        if (parseInt(chunk) > 0) {
          let text = threeDigitsToWord(chunk);
          if (thousands[counter]) text += " " + thousands[counter];
          parts.unshift(text);
        }
        counter++;
      }

      return parts.join(" و ") + " تومان";
    },
    ReloadMethods1() {
      let self = this;
      this.PageShow1 += 1;

      this.helperGet_taxi(
        "get-customer-credit-history",
        "type=" +
          "all" +
          "&uid=" +
          self.$store.state.auth_taxi.uid +
          "&page=" +
          self.PageShow1
      ).then((json) => {
        self.SearchList1 = self.SearchList1.concat(json.data.data.list);
      });
    },

    ShowMoneyToUSer(value) {
      console.log(value);
      this.credit = this.formatPrice(value.replace(/[^\d.-]/g, ""));
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(",", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    price_input(event) {
      let self = this;
      self.credit = self.formatPrice(
        event.target.value.replace(/[^\d.-]/g, "")
      );
    },

    getInfo() {
      this.userBox = this.$store.state.auth_taxi;
      this.optionUser = this.$store.getters.taxi_c_set;
      console.log(this.optionUser);
      this.ReloadMethods1();
    },
    async BtnCharge() {
      var price = this.credit.split(",").join("");
      console.log("price", price);
      if (this.credit == "") {
        this.snackbar = true;
        toast.error("لطفا مبلغ را وارد کنید");
      } else {
        this.helperPost_taxi("charge-credit", {
          uid: this.userBox.uid,
          price: price,
        }).then((json) => {
          console.log(json);
          if (json.data.result == "1") {
            var url = json.data.data.url;
            window.location.href = url;
          } else {
            toast.error(json.data.msg);
          }
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.wallet {
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  direction: rtl;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
  background: #fff;

  .walletBg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  .walletContent {
    position: relative;
    z-index: 2;
    width: 90%;
    margin-left: auto;
    margin-right: auto;

    .contentTopNav {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 20px 0 0;

      .navTitle {
        font-family: "iranyekanB", sans-serif;
        font-size: 1.1rem;
        color: #fff;
        display: flex;
        align-items: center;
        gap: 8px;

        svg {
          width: 28px;
          height: 28px;
        }
      }

      .backBtn {
        cursor: pointer;
        color: #fff;

        svg {
          width: 28px;
          height: 28px;
          stroke-width: 2.5;
        }
      }
    }

    .contentHeader {
      width: 100%;
      padding: 52px 0 36px;

      .headerTitle {
        text-align: center;
        font-size: 1.5rem;
        font-family: "iranyekanB", sans-serif;
        color: #fff;
        margin-bottom: 4px;
      }

      .headerContent {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;

        .contentNum {
          font-family: "yekan", sans-serif;
          font-size: 2.25rem;
          font-weight: 800;
          color: #fff;
        }

        .contentUnit {
          font-size: 1rem;
          color: #fff;
          margin-top: 8px;
        }
      }
    }

    .contentMain {
      margin-top: 98px;
      .mainShortCuts {
        width: 90%;
        margin-left: auto;
        margin-right: auto;
        // display: flex;
        // align-items: center;
        // justify-content: center;
        gap: 16px;
        flex-wrap: wrap;
        display: grid;
        grid-template-columns: repeat(3, 1fr);

        .shortCutThumb {
          // width: 92px;
          height: 38px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #0851a0;
          color: #fff;
          font-size: 1.1rem;
          border-radius: 9999px;
          box-shadow: 0 0 6px 1px rgba(0, 0, 0, 0.4);
          transition: all 0.1s;

          &:active {
            transform: scale(0.95);
          }
        }
      }

      .mainFormWrapper {
        margin-top: 42px;

        .mainForm {
          width: 100%;
          margin-left: auto;
          margin-right: auto;
          .formGroup {
            .groupLabel {
              font-size: 1rem;
              margin-bottom: 8px;
              margin-right: 16px;
              display: block;
              color: #000;
            }
            .groupInputWrapper {
              position: relative;
              width: 100%;
              height: 44px;
              background: #f7f7f7;
              border: 1px solid #dedede;
              box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
              border-radius: 9999px;
              overflow: hidden;
              display: flex;
              align-items: center;

              .groupUnit {
                height: 100%;
                font-size: 1rem;
                padding: 0 16px;
                display: flex;
                align-items: center;
                flex-shrink: 0;
                color: #000;
              }

              .groupInput {
                flex-grow: 1;
                height: 100%;
                padding: 12px 16px;
                background: transparent;
                border-bottom-right-radius: 9999px;
                border-top-right-radius: 9999px;
                font-size: 1rem;
              }
            }
          }

          .groupSubText {
            margin-top: 8px;
            margin-right: 8px;
            font-size: 0.8rem;
            color: #0851a0;
            line-height: 16px;
          }

          .formSubmitBtn {
            width: 100%;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1rem;
            font-family: "iranyekanB", sans-serif;
            background: #0851a0;
            color: #fff;
            border-radius: 9999px;
            margin-top: 38px;
            box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
          }
        }
      }
    }
  }
}

.light {
  .ShowHistoryToDriver {
    background: #0851a0 !important;
    margin-top: 54px !important;

    h2 {
      color: #fff !important;
    }
  }
}

@media (min-width: 550px) {
  .wallet {
    padding-bottom: 92px;
  }
}
</style>
